import styled from "styled-components"
import StyledCard from "components/library/card/styled/StyledCard"

const StyledSquareCard = styled(StyledCard)`
  border-radius: 0;
  padding: 0%;
`

export default StyledSquareCard
